import { Component, Inject, OnInit } from '@angular/core';
import { EventDetailDto, PointSummaryDto, RaceDetailDto, RankingDataDto, RunnerDetectionDto, RunnerDetectionListDto, RunnerStatusEnum, runnerStatusLabel } from "@aoe/client";
import * as _ from 'lodash-es';
import { PictureRunnerItem } from 'src/app/core/interfaces/item/PictureRunnerItem.interface';
import { RankingItem } from 'src/app/core/interfaces/item/RankingItem.interface';
import { VideoRunnerItem } from 'src/app/core/interfaces/item/VideoRunnerItem.interface';
import { DialogService } from 'src/app/core/services/dialog.service';
import { PicturesService } from 'src/app/core/services/pictures.service';


import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { catchError, filter, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { formatShortDateTimeWithSecond, timestampToTimeString } from 'src/app/core/helpers/Date.helpers';
import { DetectionService } from 'src/app/core/services/detection.service';
import { selectEventIdSelected } from 'src/app/core/store/event/event.selector';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'aoe-runner-modal',
  templateUrl: './runner-modal.component.html',
  styleUrls: ['./runner-modal.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, FormsModule, MatTabsModule],
})
export class RunnerModalComponent implements OnInit {

  private readonly dynamicRaceType!: any;
  public pictures!: Array<PictureRunnerItem>;
  public videos!: Array<VideoRunnerItem>;
  runnerDetections$!: Observable<RunnerDetectionDto[]>;
  event!: EventDetailDto | null;
  race!: RaceDetailDto | null;
  raceSlug!: string | null;

  loadings = { videos: true, pictures: true, detections: true }


  error = {
    video: false,
    picture: false,
    detections: false
  }

  constructor(
    private readonly dialogService: DialogService,
    private readonly sanitizer: DomSanitizer,
    private readonly detectionsService: DetectionService,
    private readonly picturesService: PicturesService,
    private readonly store: Store,
    @Inject(MAT_DIALOG_DATA) public data: { runner: RankingItem, points: Array<PointSummaryDto>, race: RaceDetailDto },
  ) { }

  ngOnInit(): void {

    this.runnerDetections$ = this.store.select(selectEventIdSelected).pipe(
      filter(id => !!id),
      take(1),
      switchMap((eventId) => {
        if (eventId) {
          return this.detectionsService.getDetections({ eventId: eventId }, { chip: this.data.runner.runner.bib, isActive: true })
        } else {
          return of({ data: new RunnerDetectionListDto() })
        }
      }

      ),
      map((res) => res?.data?.detections ?? []),
      tap(() => (this.loadings.detections = false)),
      catchError(() => {
        this.error.detections = true;
        this.loadings.detections = false;
        return of([]); // Retourne un tableau vide en cas d'erreur
      })
    );


    console.log(this.data);


    // this.subs.add(this.store.select(selectEventSelected).pipe(filter(id => !!id), take(1)).subscribe(event => this.event = event ?? null));

    // if (this.data.runner.status === RunnerStatusEnum.FINISHER) {
    //   forkJoin({
    //     photos: this.picturesService.getPicturesRunner(this.data.race.eventId, this.data.runner.runner.bib),
    //     videos: this.videoService.getVideoRunner(this.data.race.eventId, this.data.runner.runner.bib)
    //   }).subscribe({
    //     next: (res) => {
    //       this.pictures = res.photos.data ?? [];
    //       this.videos = res.videos.data ?? [];
    //       this.loadings = { ...this.loadings, videos: false, pictures: false }
    //     },
    //     error: () => {

    //     }
    //   })
    // }

    // if (this.data.runner.status !== RunnerStatusEnum.NOT_STARTED) {
    //   this.runnerService.getRunnerDetection(this.event?.id, this.data.runner.runner.id).pipe(tap(() => this.loadings.dectections = false)).subscribe({
    //     next: (res) => {
    //       if (res.data)
    //         this.runnerDetections = res.data.detections;
    //     },
    //     error: () => {
    //       this.error.detections = true;
    //     }
    //   })
    // }

  }

  get raceColor() {
    return this.data.race?.color;
  }

  get runnerName(): string {
    return `${this.data.runner.runner.firstName} ${this.data.runner.runner.lastName}`
  }

  /**
 * Calcule le temps écoulé entre le point actuel et le point précédent
 * @param index Index de la détection courante dans le tableau
 * @param detections Liste complète des détections du coureur
 */
  getDiffTimeFromPrevious(index: number, detections: RunnerDetectionDto[]): string | null {
    // Pas de temps intermédiaire pour le point de départ (index 0)
    if (index === 0 || !detections[index] || !detections[index - 1]) {
      return null;
    }

    const currentPassage = new Date(detections[index].raceTime).getTime();
    const previousPassage = new Date(detections[index - 1].raceTime).getTime();

    // Différence en secondes
    const diffInSeconds = Math.max(0, Math.floor((currentPassage - previousPassage) / 1000));

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    // Formatage HH:mm:ss ou mm:ss
    const pad = (num: number) => num.toString().padStart(2, '0');

    if (hours > 0) {
      return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
    }
    return `${pad(minutes)}m ${pad(seconds)}s`;
  }

  // get passages(): Array<RunnerDetectionDto> {
  //   return this.runnerDetections ?? [];
  // }

  // get hasDetection() {
  //   return !!this.passages.length;
  // }

  // get timingData(): RunnerDetectionDto[] {
  //   return this.runnerDetections ?? null;
  // }

  // get raceTime(): string | null {
  //   console.log(this.runnerDetections?.time, this.data.runner.timming?.cumulatedTiming);

  //   return timestampToTimeString((this.runnerDetections?.time ?? 0) * 1000)
  // }

  get club(): string {
    return this.data.runner.runner.club;
  }

  get bib(): number {
    return this.data.runner.runner.bib;
  }

  get raceLabel(): string {
    return this.data.race.name ?? ''
  }

  get raceDuration(): string {
    return timestampToTimeString(this.dynamicRaceType)
  }

  get isOnRace(): boolean {
    return this.data.runner.status === RunnerStatusEnum.ON_RACE;
  }

  get status(): string {
    return runnerStatusLabel(this.data.runner.status)
  }

  get points(): Array<any> {
    return this.data.points;
  }

  get category(): string {
    return `${this.data.runner.runner.category?.event ?? ''}${this.data.runner.runner.sex ?? ''}`
  }

  get sex(): string {
    return this.data.runner.runner.sex
  }

  get rankings(): RankingDataDto | null {
    return this.data.runner.rank
  }

  get country(): string {
    return this.data.runner.runner.country
  }

  get hasPicture(): boolean {
    return _.isUndefined(this.pictures) ? false : this.pictures.length > 0;
  }

  get hasVideos(): boolean {
    return _.isUndefined(this.videos) ? false : this.videos.length > 0;
  }

  // get speed() {
  //   return this.runnerDetections.speed ? Math.trunc(this.runnerDetections.speed * 10) / 10 : null;
  // }

  // public getPointsRunnerData(cpid: number): RunnerDetectionDto | undefined {
  //   return this.passages.find((p: any) => p.point.cpid == cpid)
  // }
  public getThumbnailsVideo(videoId: string): string {
    return `${environment.apiUrl}/video/${videoId}/thumbnail`;
  }

  // getTimeToPointFromStart(cpid: number) {
  //   if (cpid === 0)
  //     return null;
  //   const point = this.getPointsRunnerData(cpid);
  //   if (point) {
  //     const firstPoint = new Date(this.runnerDetections.detections[0].time).getTime();
  //     const pointDateTime = new Date(point.time).getTime();
  //     return timestampToTimeString(pointDateTime - firstPoint);
  //   }
  //   return null;
  // }

  // public getTimeFromLastPoint(cpid: number) {
  //   const point = this.getPointsRunnerData(cpid);
  //   if (point)
  //     return timestampToTimeString(point.cumulatedTime);
  //   return null;
  // }

  // public getPassageDateTime(point: any): string | null {
  //   const passage = this.getPointsRunnerData(point.cpid);
  //   if (passage) {
  //     return passage.time;
  //   }
  //   return null;
  // }

  public close() {
    this.dialogService.closeRunnerModal();
  }

  public getPicture(pictureId: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.apiUrl}/picture/${pictureId}`)
  }

  public getPointData(passage: any): PointSummaryDto | undefined {
    return this.data.points.find((p: any) => p.cpid === passage.cpid)
  }

  public getPointDateTimeFormated(dateTime: string): string {
    return dateTime !== '0' ? formatShortDateTimeWithSecond(new Date(dateTime)) : '-';
  }

  public getCountryFlagUrl(countryCode: string): SafeUrl {
    if (countryCode)
      return this.sanitizer.bypassSecurityTrustResourceUrl(`https://flagcdn.com/${countryCode.slice(0, 2).toLowerCase()}.svg`);
    return ''
  }

  public downloadPicture(pictureId: string): void {
    this.picturesService.downloadPicture(pictureId, this.raceLabel, this.runnerName);
  }

  openDialogVideo(videoId: string) {
    this.dialogService.openVideoModal(videoId)
  }

}
